import React from 'react';

import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";

export const GamesPredictionsWidgetHeaderPlaceholder = (props) => {
  return (
    <PlaceholderWrapperComponent className={'games-predictions-widget-header-placeholder-container'}>
      <div className={'games-predictions-widget-header-placeholder-content'}>
        <div className={'games-predictions-widget-header-placeholder'}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
